module.exports = __webpack_public_path__ + "favicon/favicon_310.4fb90897.png";